import { ObservableMap } from '@stencil/store';
import { User } from 'oidc-client-ts';

import { getEnvConfigField } from '../utils/EnvironmentUtil';
import Logger from '../utils/logger/logger';
import {
    checkSession,
    getAccessToken,
    initializeUserManager,
    isSingleSessionEnforcementEnabled,
    setAccessToken,
} from '../utils/sessionHelper';
import { State } from './types/state';

export async function signInSilent(
    store: ObservableMap<State>,
    enforceSingleSessionFlag: boolean,
    enableLocal: boolean,
) {
    try {
        Logger.debug('session', 'signInSilent', { state: store.state });
        const userManagerInitialized = initializeUserManager(store, enforceSingleSessionFlag, enableLocal);
        if (!userManagerInitialized) {
            throw new Error('UserManager missing');
        }

        store.set('isSignInInitialized', true);
        Logger.debug('session', 'calling signInSilent on userManager', { state: store.state });
        const returnedUser: User | null = await userManagerInitialized.signinSilent();

        if (!returnedUser) {
            throw new Error('Returned user is null');
        }

        setAccessToken(store, returnedUser);

        if (enforceSingleSessionFlag) { // If the flag is on, we want to poll for session validity, even if the setting is not false
            const allowConcurrentSessionsSetting = isSingleSessionEnforcementEnabled(store, enforceSingleSessionFlag);
            Logger.info('session', `starting /checksession poll; allowConcurrentSessionSetting&&Flag=${allowConcurrentSessionsSetting}`, { state: store.state });
            const sessionCheckValue = getEnvConfigField('SESSION_CHECK_VALUE');
            setInterval(
                () => checkSession(getAccessToken(store, returnedUser.access_token), store),
                sessionCheckValue ? sessionCheckValue * 1000 : 30 * 1000,
            );
        }

        return true;
    } catch (error) {
        Logger.error('session', `sign in silent error: ${error.message}`, { state: store.state });
        store.set('isSignInInitialized', false);
        return false;
    }
}
